const rayglass = rayglass || {};

const init = function (rayglass, $, window, document, undefined) {

	// private consts
	//
	const _d = document;
	const _b = _d.body;
	const _w = window;

	// carousels
	//
	const doSlickCarousel = function doSlickCarouselFn() {
		


		// home page hero slider
		// $('.js-slick-hero').on('init', function( event, slick ) {
		// 	$('.current').text(slick.currentSlide+1);
		// 	$('.total').text(slick.slideCount);
		// });

		$('.js-slick-hero').slick({
			fade: true,
			lazyLoad: 'progressive',
			slidesToShow: 1,
			dots: true,
			arrows: false,
			slidesToScroll: 1,
			initialSlide: 0,
            autoplay: true,
            autoplaySpeed: 6000,
			adaptiveHeight: true
		});
		// .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		//   $('.current').text(nextSlide+1);
		// });



		$('.js-slick-header').slick({
			fade: true,
			lazyLoad: 'progressive',
			slidesToShow: 1,
			dots: true,
			arrows: false,
			slidesToScroll: 1,
			initialSlide: 0,
			autoplay: false
		});



		// feature module
		$('.js-slick-feature').slick({
			lazyLoad: 'progressive',
			slidesToShow: 1,
			dots: false,
			arrows: true,
			slidesToScroll: 1,
			initialSlide: 0,
			autoplay: false
		});



		// model slider - legend
		// feature module
		$('.js-slick-models-legend').slick({
			fade: true,
			slidesToShow: 1,
			dots: true,
			arrows: false,
			slidesToScroll: 1,
			initialSlide: 0,
			autoplay: false,
			draggable: false,
			appendDots: '.js-slick-dots-legend'
		});

		// model slider - chase
		// feature module
		$('.js-slick-models-chase').slick({
			fade: true,
			slidesToShow: 1,
			dots: true,
			arrows: false,
			slidesToScroll: 1,
			initialSlide: 0,
			autoplay: false,
			draggable: false,
			appendDots: '.js-slick-dots-chase'
		});




		// timeline
		$('.js-slick-timeline').slick({
			initialSlide: 0,
			autoplay: true,
			draggable: true,
			slidesToShow: 3,
			responsive: [
			    {
			      breakpoint: 1200,
			      settings: {
			        slidesToShow: 3,
			      }
			    },
			    {
			      breakpoint: 900,
			      settings: {
			        slidesToShow: 2,
					infinite: true
			      }
			    },
			    {
			      breakpoint: 600,
			      settings: {
			        slidesToShow: 1,
			        slidesToScroll: 1,
			        dots: false
			      }
			    }
			  ]
		});


		// model category listing block
		$('.range-models---desktop-carousel').slick({									
			slidesToScroll: 1,
			variableWidth: true,
			dots: false,
			infinite: true,
			arrows: true
		});



		
		var mobileRangeSettings = {
			slidesToScroll: 1,
			variableWidth: true,
			dots: false,
			infinite: true,
			arrows: true
		}

		var $fiveRangeSlider = $('.range-models---mobile-only-carousel.five-items');
		if ($fiveRangeSlider.length > 0) {
			trigger_slick_on_mobile($fiveRangeSlider, mobileRangeSettings, 1259);
		}

		var $fourRangeSlider = $('.range-models---mobile-only-carousel.four-items');
		if ($fourRangeSlider.length > 0) {
			trigger_slick_on_mobile($fourRangeSlider, mobileRangeSettings, 1009);
		}

		var $threeRangeSlider = $('.range-models---mobile-only-carousel.three-items');
		if ($threeRangeSlider.length > 0) {
			trigger_slick_on_mobile($threeRangeSlider, mobileRangeSettings, 559);
		}

	};


	const doFixedNavigation = function doFixedNavigationFn() {
		
		
		// if scrolled past x px, apply fixed header class
		const scrollThreshold = 1;
		
		$(document).scroll( function() {

      		// top of scroll
      		if( $(_w).scrollTop() >= 1 ) {
				$(_b).addClass('has-fixed-header');
			}else{
				$(_b).removeClass('has-fixed-header');
			}
		})
	};



	const doTabs = function doTabsFn(){

		const allTabContent = $('.tabs__content');
		const allTabLinks = $('.tabs__link');


		$(_d).on('click', '.tabs__link', function( e ){

			allTabContent.removeClass('active');
			allTabLinks.removeClass('active');

			$(this).addClass('active');			
			$('#'+e.currentTarget.dataset.tab).addClass('active');

			// initialise slick sliders to calc height/width when
			// initialised in a disply:none block e.g. the hidden tab
			$('[class^=js-slick-models]').slick('setPosition');

			e.preventDefault();

		});



		$(_d).on('click', '.inner-tab-nav__link', function( e ){

			// deactivate other tabs (just in this main tab not all inner tabs)
			$(this).parents('.tabs__content').find('.inner-tab-nav__link, .inner-tab__content').removeClass('active');

			// sctivate tab
			$(this).addClass('active');			
			$('#'+e.currentTarget.dataset.tab).addClass('active');

			e.preventDefault();

		});

	}



	// rollover images
	// hover class for showing subnav
	const doNavigation = function doNavigationFn(){

		// toggle sub-nav
		const siteHeader = $('.site-header');
		const parentLink = $('.has-sub-nav');

		parentLink.on('mouseenter', function( e ){

			closeSubNavs();
			
			const el = $(this);

			$(el).find('.sub-nav').addClass('active');
			siteHeader.addClass('sub-nav-active');

		}).on('mouseleave', function( e ){
			
			closeSubNavs();

		});


		const parentMegaLink = $('.has-mega-nav');

		parentMegaLink.on('mouseenter', function (e) {

			closeSubNavs();

			const el = $(this);

			$(el).find('.mega-nav').addClass('active');
			siteHeader.addClass('mega-nav-active');

		}).on('mouseleave', function (e) {

			closeSubNavs();

		});


		var closeSubNavs = function () {
			$('.sub-nav.active').removeClass('active');
			$('.mega-nav.active').removeClass('active');
			siteHeader.removeClass('sub-nav-active');
			siteHeader.removeClass('mega-nav-active');
		}

	}



	const doMegaSubNavigation = function doMegaSubNavigationFn() {

		// toggle sub-nav
		const wrapper = $('.meganav__content--tiles');
		const allChildPanels = $('.meganav__content--tiles-children');
		const megaSubNavLink = $('.meganav__content--sidenav-link');

		megaSubNavLink.on('mouseenter', function (e) {

			closeMegaSubNavs();

			const el = $(this);

			var linkId = $(el).data('meganavId');
			var panelToShow = wrapper.find("[data-meganav-parent-id='" + linkId + "']");
			panelToShow.addClass('active');


		});

		var closeMegaSubNavs = function () {
			allChildPanels.removeClass('active');			
		}

	}




    const doArticle = function doArticleFn() {
        var $latestTag = $('#js-tag-default');
        var $articleList = $('#article-list');
        var nodeId;
        var pageIndex = 1;
        var maxPage;
        var $selectedTags = [];

        function resetPagination() {
            pageIndex = 1;
            maxPage = $('#maxPage').val();
        }

        function toggleTag() {
            $('.js-filter-tag').click(function () {
                var _text = $(this)[0].innerText;

                var i = $selectedTags.indexOf(_text);
                if (i > -1) {
                    $selectedTags.splice(i, 1);
                    $(this).removeClass('current');
                }
                else {
                    $selectedTags.push(_text);
                    $(this).addClass('current');
                }

                loadFirstPageArticleContent(nodeId, $selectedTags);

                if ($selectedTags.length == 0) {
                    $latestTag.addClass('current');                    
                }
                else {
                    $latestTag.removeClass('current');
                }
            });

            $($latestTag).click(function () {
                
                if ($(this)[0].classList.contains('current')) {
                    //do nothing
                }
                else {
                    $(this)[0].classList.add('current');

                    var _tagElements = $('.js-filter-tag').toArray();
                    _tagElements.forEach(function (element) {
                        element.classList.remove('current')                        
                    });

                    $selectedTags = [];
                    loadFirstPageArticleContent(nodeId, $selectedTags);
                }
            });

        }

        function loadPagedContent(_nodeId, _pageIndex, _selectedTags) {
            var $loadMoreBtn = $('.js-load-more-news');

            $.ajax({
                url: '/umbraco/surface/Article/PagedArticle',
                data: {
                    'nodeId': _nodeId,
                    'page': _pageIndex,
                    'tags': JSON.stringify(_selectedTags)
                },
                type: 'GET',
                success: function (data) {
                    if (data !== '' && data.length > 5) {
                        $(data).appendTo('.paged-articles').hide().fadeIn('slow');
                        if (_pageIndex == maxPage) {
                            $loadMoreBtn.hide();
                        }                        
                        $loadMoreBtn.text('Load more').prop('disabled', false);			            
                    }
                    else {
                        $loadMoreBtn.delay(600).fadeOut();
                    }
                },
                error: function () {
                    console.log('error!');
                }
            });
        }

        function loadFirstPageArticleContent(_nodeId, _selectedTags) {
            $.ajax({
                url: '/umbraco/surface/Article/ArticleList',
                data: {
                    'nodeId': _nodeId,
                    'page': 1,
                    'tags': JSON.stringify(_selectedTags)
                },
                type: 'GET',
                success: function (data) {
                    if (data !== '' && data.length > 5) {
                        $articleList.empty();
                        $(data).appendTo($articleList).hide().fadeIn('slow');
                    }
                    else {
                        //no result
                    }

                    resetPagination();
                },
                error: function () {
                    console.log('error!');
                }
            });
        }

        function triggerArticleFilter() {
            if ($articleList.length) {
                nodeId = $('#article-list').data('nodeid');
                resetPagination();
                toggleTag();
            }

            $(document).on('click', '.js-load-more-news', function (e) {
                $(this).text('loading').prop('disabled', true);
                pageIndex++;

                 setTimeout( function(){
                     loadPagedContent(nodeId, pageIndex, $selectedTags);
			    }, 400 );

                return false;
            });
        }

        triggerArticleFilter();
	}




	const doMobileMenu = function doMobileMenuFn() {

		// hamburger
		const _brgr = document.getElementById('js-toggle-menu');
		const _mobileLink = $('.mobile-nav__firstlevel-link');
		const _mobileSubLink = $('.mobile-nav__secondlevel-link');

		const wrapper = $('.mobile-nav__sub-panels');
		const allChildPanels = $('.mobile-nav__sub-panel');

		const returnLink = $('.mobile-nav_sub-panel-return');

		$(_brgr).on('click', function (e) {

			$('.mobile-nav__sub-panel').removeClass('active');
			
			// toggle active class on button
			$(this).toggleClass('is-active');

			//toggle class on body
			$(_b).toggleClass('mobile-nav-active');

			e.preventDefault();
		});


		$(_mobileLink).on('click', function (e) {

			allChildPanels.removeClass('active');

			const el = $(this);

			var linkId = $(el).data('mobilelinkId');
			var panelToShow = wrapper.find("[data-mobilelink-parent-id='" + linkId + "']");
			panelToShow.addClass('active');

			e.preventDefault();
		});

		$(_mobileSubLink).on('click', function (e) {
			const el = $(this);

			var linkId = $(el).data('mobileSecondlevellinkId');
			console.log('link id ', linkId);
			var panelToShow = wrapper.find("[data-mobilelink-secondlevellink-parent-id='" + linkId + "']");
			console.log('panel to show', panelToShow);
			panelToShow.addClass('active');

			e.preventDefault();
		});

		$(returnLink).on('click', function (e) {

			const el = $(this);
			var thisPanel = el.parents('.mobile-nav__sub-panel');
			thisPanel.removeClass('active');

			e.preventDefault();
		});
		
	}; 






	const doToggleLoopForm = function doToggleLoopFormFn(){

		const _toggleBtn = $('.js-toggle-in-the-loop-form');

		_toggleBtn.on('click', function( e ){

			$(this).parents('.module').find('.in-the-loop-form').toggleClass('open');

			e.preventDefault();
		});
	}



	/* 
   * ANIMATIONS
   */

	const  doAnimationsInit = function doAnimationsInitFn() {

		const  scroll = window.requestAnimationFrame || function(callback){ 
		  window.setTimeout( callback, 1000/60); 
		};

		const  elementsToShow = document.querySelectorAll('.animate');

		function loop() {

			elementsToShow.forEach(function (element) {
				if (isElementInViewport(element)) {
					element.classList.add('is-visible');
				} else {
					//element.classList.remove('is-visible');
				}
			});

			scroll(loop);
		}

		function isElementInViewport(el) {

			// special bonus for those using jQuery
			if (typeof jQuery === 'function' && el instanceof jQuery) {
			el = el[0];
			}

			const  rect = el.getBoundingClientRect();

			return (
				   (rect.top <= 0 && rect.bottom >= 0) 
				|| (rect.bottom >= (window.innerHeight 
				|| document.documentElement.clientHeight) && rect.top <= (window.innerHeight 
				|| document.documentElement.clientHeight)) 
				|| (rect.top >= 0 && rect.bottom <= (window.innerHeight 
				|| document.documentElement.clientHeight))
			);
		}

		loop();

	};

	// https://www.npmjs.com/package/js-datepicker
	const doDatePicker = function doDatePickerFn(){
		
		if( $('.js-date-picker').length != '' ) {
			console.log('yep - datepickers here');

			const picker = datepicker('.js-date-picker', {
				noWeekends: true,
				formatter: (input, date, instance) => {
					const value = date.toLocaleDateString()
					input.value = value // => '1/1/2099'
				}
			});
		}
	}


	const doInstaWidget = function doInstaWidgetFn(){
        var $instawidget = $('#instawidget');

        function fetchInstagramFeeds() {
            var _url = '/umbraco/api/Instagram/GetFeeds';
            $.ajax({
                type: 'GET',
                url: _url,
                contentType: 'application/json',
                success: function (response) {
                    var data = JSON.parse(response);

                    $.each(data, function (i, obj) {
                        $instawidget.append('<a href="' + obj.permalink + '" target="_blank"><img src="' + obj.media_url + '" alt="' + obj.caption + '"></a>');
                    });

                },
                error: function (err) {
                    console.log(err);
                    $instawidget.append('Error fetching Instagram media. Please try again later');
                }
            });
        }

        if ($instawidget.length != '' ) {
            fetchInstagramFeeds();          
		}
	}

    const doNewsletter = function doNewsletterFn() {
        var $name = $('#newsletterName');
        var $email = $('#newsletterEmail');
        var $btnSubmit = $('.js-newsletter-btn');
        var $message = $('#js-newsletter-message');

        function formValidation() {
            var form = $('.js-newsletter-form')[0];
            for (var i = 0; i < form.elements.length; i++) {
                if (form.elements[i].value === '' && form.elements[i].hasAttribute('required')) {
                    return false;
                }
            }
        }

        function subscribe() {

            $btnSubmit.on("click", function (event) {
                if (formValidation() == false) {
                    $message.css({ 'color': 'red' });
                    $message.html('Both fields are mandatory.');
                    $message[0].style.display = 'block';
                    return false;
                }

                event.preventDefault();

                var _model = {
                    "Name": $name.val(),
                    "Email": $email.val(),
                    "SiteId": $('.js-newsletter-form')[0].getAttribute('data-siteid')
                };

                var _url = '/umbraco/api/newsletter/send';
                $.ajax({
                    type: 'POST',
                    url: _url,
                    contentType: 'application/json',
                    data: JSON.stringify(_model),
                    success: function (response) {
                        //console.log(response);
                        if (response.StatusCode == 400) {
                            $message.css({ 'color': 'red' });
                            $message.html(response.Message);
                            $message[0].style.display = 'block';
                        }
                        else {
                            $btnSubmit.hide();
                            $name.val(null);
                            $email.val(null);
                            $message.css({ 'color': 'white' });
                            $message.html(response.Message);
                            $message[0].style.display = 'block';
                        }

                    },
                    error: function (response) {
                        console.log(response);
                        $message.css({ 'color': 'red' });
                        $message.html('Something went wrong. Please try again later.');
                        $message[0].style.display = 'block';
                    }
                });

                return false;
            });
        }

        subscribe();
    }

	// jQuery onReady
	//
	$(function() {

		doSlickCarousel();

		doFixedNavigation();

		doTabs();

		doArticle();

		doNavigation();

		doMegaSubNavigation();

		doMobileMenu();

		doToggleLoopForm();

		doAnimationsInit();

		doDatePicker();

        doInstaWidget();

		doNewsletter();

		lightbox.option({
			'resizeDuration': 200 
		})

	});

}(rayglass, jQuery, window, document);



function trigger_slick_on_mobile(slider, settings, breakpoint) {
	$(window).on('load resize', function () {
		if ($(window).width() > breakpoint) {
			if (slider.hasClass('slick-initialized')) {
				slider.slick('unslick');
			}
			return;
		}
		if (!slider.hasClass('slick-initialized')) {
			return slider.slick(settings);
		}
	});
};